// extracted by mini-css-extract-plugin
export var content = "_75-3";
export var list = "_75-4";
export var settingsContent = "_75-7";
export var settingsPanel = "_75-8";
export var state = "_75-6";
export var triggerBadge = "_75-2";
export var triggerButton = "_75-1";
export var triggerShell = "_75-0";
export var unreadDot = "_75-5";